var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31429 4.31571C6.21466 4.41514 6.13562 4.53323 6.08169 4.66325C6.02776 4.79326 6 4.93263 6 5.07338C6 5.21413 6.02776 5.35351 6.08169 5.48352C6.13562 5.61353 6.21466 5.73163 6.31429 5.83105L10.4842 10.0009L6.31429 14.1708C6.11335 14.3718 6.00046 14.6443 6.00046 14.9285C6.00046 15.2127 6.11335 15.4852 6.31429 15.6862C6.51524 15.8871 6.78778 16 7.07196 16C7.35615 16 7.62869 15.8871 7.82964 15.6862L12.7626 10.7532C12.8622 10.6538 12.9412 10.5357 12.9952 10.4057C13.0491 10.2757 13.0769 10.1363 13.0769 9.99556C13.0769 9.85481 13.0491 9.71544 12.9952 9.58543C12.9412 9.45541 12.8622 9.33732 12.7626 9.23789L7.82964 4.30496C7.42125 3.89657 6.73343 3.89657 6.31429 4.31571Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNext);
export default __webpack_public_path__ + "static/media/ic-next.68e9a11d514ad016f52c4353011ca1ee.svg";
export { ForwardRef as ReactComponent };